import { render, staticRenderFns } from "./tzIndex.vue?vue&type=template&id=b0495bfe"
import script from "./tzIndex.vue?vue&type=script&lang=js"
export * from "./tzIndex.vue?vue&type=script&lang=js"
import style0 from "./tzIndex.vue?vue&type=style&index=0&id=b0495bfe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports